import React from 'react'
import './taxes.css'
import Monthlyreport from '../../../../assets/Help/monthlyTaxReport.webp'
import Taxespopup from '../../../../assets/Help/tax-pop-up.webp'
import Taxdetails from '../../../../assets/Help/detailed-tax.webp'

import { useThemeContext } from '../../../../Context/ThemeContext.js';
import { DARKCOLORS, LIGHTCOLORS } from '../../../../Utils/constants.js';
import { useTranslation } from 'react-i18next';
import { Box, Divider } from '@mui/material';

const Taxes = () => {

    const { mode } = useThemeContext();
    const { t } = useTranslation();

    const containerBG = mode === 'dark' ? DARKCOLORS.BackgroundMenu : LIGHTCOLORS.BackgroundMenu;
    const subtitletext = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;
    // const titletext = mode === 'dark' ? DARKCOLORS. : LIGHTCOLORS.GreyScale10;
    const headingcolor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
    const headingcolor2 = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;

    return (
        <div className='taxes-container'>

            <div className='taxes-sec'>
                <Box className="taxes-title-sec">

                    <h2 className='tax-title home-title'>{t('help.helpTaxes')}</h2>
                    <p style={{
                        color: subtitletext
                    }} className='home-subtitle'>{t('help.helpTaxesSubtitle')}</p>

                </Box>
                <Divider className='divider' style={{ marginTop: '70px', marginBottom: '50px' }} />
<Box className=''>

                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'>{t('help.helpMonthlyTaxReport1')}  {t('help.helpMonthlyTaxReport2')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>
                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'> {t('help.helpMonthlyTaxReportText')}</p>

                            <ul className='display-list' >
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.helpMonthlyTaxReportheading2')}</span>  {t('help.helpMonthlyTaxReportText2')}</li>


                            </ul>




                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '90%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={Monthlyreport} alt="Machine Card" />

                    </Box>
                </Box>

                <Divider className='divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                <Box className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'> {t('help.helpMonthlyDetailedTaxReport1')}{t('help.helpMonthlyDetailedTaxReport2')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>
                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'>  {t('help.helpMonthlyTaxReportPoint1')}</p>

                            <ul className='display-list' >
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text  disc'> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.helpMonthlyTaxReportPoint2Heading')}</span>  {t('help.helpMonthlyTaxReportPoint2Text')}</li>


                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text  disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.helpMonthlyTaxReportPoint3Heading')} </span> {t('help.helpMonthlyTaxReportPoint3Text')} </li>

                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text  disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.helpMonthlyTaxReportPoint7Heading')} </span> {t('help.helpMonthlyTaxReportPoint7Text')}</li>

                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text  disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.helpMonthlyTaxReportPoint4Heading')} </span> {t('help.helpMonthlyTaxReportPoint4Text')} </li>

                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text  disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.helpMonthlyTaxReportPoint5Heading')}</span>{
                                    t('help.helpMonthlyTaxReportPoint5Text')} </li>

                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text  disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.helpMonthlyTaxReportPoint6Heading')} </span>{t('help.helpMonthlyTaxReportPoint6Text')}</li>


                            </ul>




                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '90%',

                            // maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={Taxdetails} alt="Machine Card" />

                    </Box>
                </Box>
                <Divider className='divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                <Box sx={{marginBottom:'50px'}} className='number-sec-container'>

                    <Box className="list-container manage-list-container">
                        <Box className='doc-inventory-title-sec'>

                            <p className='number-structure'> {t('help.taxDetailsPopup1')} {t('help.taxDetailsPopup2')}</p>
                        </Box>

                        <Box className='manage-discription level_2'>
                            <p style={{
                                color: subtitletext, marginTop: '10px'
                            }} className='home-Navi-bar-text'> {t('help.taxDetailsPopupPoint')}
</p>

                            <ul className='display-list' >
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text  disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.taxDetailsPopupPoint2Heading')}</span>  {t('help.taxDetailsPopupPoint2Text')}</li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text  disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.taxDetailsPopupPoint3Heading')} </span>   {t('help.taxDetailsPopupPoint3Text')} </li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text  disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.taxDetailsPopupPoint4Heading')}</span>  {t('help.taxDetailsPopupPoint4Text')}</li>
                                <li style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text  disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.taxDetailsPopupPoint5Heading')}</span> {t('help.taxDetailsPopupPoint5Text')} <br/>{t('help.taxDetailsPopupPoint5SubText1')}<br/>{t('help.taxDetailsPopupPoint5SubText2')}</li>
                            </ul>




                        </Box>
                    </Box>
                    <Box className='nav-svg-sec' >
                        <img style={{
                            backgroundColor: 'white', borderRadius: '5px',
                            width: '90%',

                            maxHeight: '500px',
                            // marginTop: '12px',
                        }} src={Taxespopup} alt="Machine Card" />

                    </Box>
                </Box>

                </Box>

            </div>




        </div>
    )
}

export default Taxes